module.exports = __webpack_public_path__ + "img/security_1.a193f348.png";